import { useAtom } from 'jotai'

import {
  VIPListAtom,
  campaignFiles,
  deleteFileIds,
  uploadFileIds,
  uploadProducts,
  VIPCampaignListAtom,
  VIPCampaignProductListAtom,
  vipCampaignProductListAllAtom,
  selectedGiveAwayProductAtom,
  selectedCampaignProductAtom,
} from '../store/list'
import { VIPDetailAtom } from '../store/detail'
import { ProgramDetailAtom, PrevProgramDetailAtom } from '../store/program'

export const useVIP = () => {
  const [VIPList, VIPListSet] = useAtom(VIPListAtom)
  const [VIPCampaignList, VIPCampaignListSet] = useAtom(VIPCampaignListAtom)
  const [detail, detailSet] = useAtom(VIPDetailAtom)
  const [program, programSet] = useAtom(ProgramDetailAtom)
  const [prevProgram, prevProgramSet] = useAtom(PrevProgramDetailAtom)
  const [vipCampaignProductList, vipCampaignProductListSet] = useAtom(VIPCampaignProductListAtom)
  const [vipCampaignProductListAll, vipCampaignProductListAllSet] = useAtom(vipCampaignProductListAllAtom)

  const [selectedGiveAwayProduct, selectedGiveAwayProductSet] = useAtom(selectedGiveAwayProductAtom)
  const [selectedCampaignProduct, selectedCampaignProductSet] = useAtom(selectedCampaignProductAtom)

  const [campaignFilesState, campaignFilesSet] = useAtom(campaignFiles)

  const [uploadFileIdsState, uploadFileIdsSet] = useAtom(uploadFileIds)
  const [uploadProductsState, uploadProductsSet] = useAtom(uploadProducts)

  const [deleteFileIdsState, deleteFileIdsSet] = useAtom(deleteFileIds)

  return {
    VIPList,
    VIPListSet,
    detail,
    detailSet,
    program,
    programSet,
    prevProgram,
    prevProgramSet,
    VIPCampaignList,
    VIPCampaignListSet,
    vipCampaignProductList,
    vipCampaignProductListSet,
    vipCampaignProductListAll,
    vipCampaignProductListAllSet,

    selectedGiveAwayProduct,
    selectedGiveAwayProductSet,

    selectedCampaignProduct,
    selectedCampaignProductSet,

    campaignFilesState,
    campaignFilesSet,

    uploadFileIdsState,
    uploadFileIdsSet,

    uploadProductsState,
    uploadProductsSet,

    deleteFileIdsState,
    deleteFileIdsSet,
  }
}
